import { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import useCanScan from "../../hooks/useCanScan";

const RouteCanScan: FC<{ children: ReactNode }> = ({ children }) =>
  useCanScan() ? <>{children}</> : <Navigate to="/404" replace />;

export default RouteCanScan;
